import React from 'react'
import { BoxCenter } from '../../../generic/Box'
import Loader from '../../../generic/Loader'
import { inject, observer } from 'mobx-react'
import Title from '../../../generic/Title'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const NFECertDate = inject('nfsStore')(observer(props => {
  const { nfsStore } = props
  const { isFetching, date, isValid } = nfsStore.state.certificate
  const icon = isValid ? (
    <FontAwesomeIcon icon={['far', 'check-circle']} size='5x' className='success-icon' />
  ) : (
    <FontAwesomeIcon icon={['far', 'times-circle']} size='5x' className='error-icon' />
  )
  return (
    <BoxCenter>
      <Title>Data de expiração do certificado</Title>
      <Loader isLoading={isFetching}>
        <Title size={4}>
          {date.toLocaleString('pt-br')}
        </Title>
        {icon}
      </Loader>
    </BoxCenter>
  )
}))

export default NFECertDate



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfs/NFSCertDate.js